export const SWAPCARD_API_KEY = 'NjRmOGI1NDhkNzdiNWQxZDNlNTEyZGQxOjA4ZGJiYWU3YzE0NzQ0NWY4YmNkN2RlMGRjYzFhNWNj';
export const EVENT_ID = 'RXZlbnRfMTAxNjc1Ng==';
export const SPEAKERS_GROUP_ID = '"RXZlbnRHcm91cF8xOTgwOTk=';
